<template>
    <div v-if="depth_chart">

        <h3>{{team_role}} {{ depth_chart.name }} {{ depth_chart.market }}</h3>

        <div v-if="depth_chart.defense">
            <h4>defense - type: {{ depth_chart.defense.type }}</h4>

            <table class="table">
                <tr>
                    <th>name</th>
                    <th>desc</th>
                    <th>players</th>
                </tr>
                <tr v-for="position in depth_chart.defense.positions">
                    <td>{{ position.name }}</td>
                    <td>{{ position.desc }}</td>
                    <td>
                        <table class="table">
                            <tr>
                                <th>id</th>
                                <th>name</th>
                                <th>depth</th>
                                <th>jersey_number</th>
                                <th>position</th>
                                <th>status</th>
                            </tr>
                            <tr v-for="player in position.players">
                                <td>{{ player.id}}</td>
                                <td>{{ player.name}}</td>
                                <td>{{ player.depth}}</td>
                                <td>{{ player.jersey_number}}</td>
                                <td>{{ player.position}}</td>
                                <td>{{ player.status}}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>

        <div v-if="depth_chart.offense">
            <h4>offense</h4>

            <table class="table">
                <tr>
                    <th>name</th>
                    <th>desc</th>
                    <th>players</th>
                </tr>
                <tr v-for="position in depth_chart.offense.positions">
                    <td>{{ position.name }}</td>
                    <td>{{ position.desc }}</td>
                    <td>
                        <table class="table">
                            <tr>
                                <th>id</th>
                                <th>name</th>
                                <th>depth</th>
                                <th>jersey_number</th>
                                <th>position</th>
                                <th>status</th>
                            </tr>
                            <tr v-for="player in position.players">
                                <td>{{ player.id}}</td>
                                <td>{{ player.name}}</td>
                                <td>{{ player.depth}}</td>
                                <td>{{ player.jersey_number}}</td>
                                <td>{{ player.position}}</td>
                                <td>{{ player.status}}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>

        <div v-if="depth_chart.special_teams">
            <h4>special_teams</h4>

            <table class="table">
                <tr>
                    <th>name</th>
                    <th>desc</th>
                    <th>players</th>
                </tr>
                <tr v-for="position in depth_chart.special_teams.positions">
                    <td>{{ position.name }}</td>
                    <td>{{ position.desc }}</td>
                    <td>
                        <table class="table">
                            <tr>
                                <th>id</th>
                                <th>name</th>
                                <th>depth</th>
                                <th>jersey_number</th>
                                <th>position</th>
                                <th>status</th>
                            </tr>
                            <tr v-for="player in position.players">
                                <td>{{ player.id}}</td>
                                <td>{{ player.name}}</td>
                                <td>{{ player.depth}}</td>
                                <td>{{ player.jersey_number}}</td>
                                <td>{{ player.position}}</td>
                                <td>{{ player.status}}</td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    
</template>

<script>
export default {
    name: 'NFLDepthChart',
    props: {
        depth_chart: '',
        team_role: '',
    },
    data: function() {
        return {            
            
        }
    }, 
}
</script>

